import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { QuotesService } from '../../../core/data/services/quotes.service';

export const quoteNotIssuedGuard: CanActivateFn = (route, state) => {
    const quotesService = inject(QuotesService);
    const router = inject(Router);

    const status = quotesService.currentQuote?.status?.toString()?.toLowerCase() || '';

    // If already issued, redirect to success page
    if (status === 'issued' || status === '2') {
        return router.createUrlTree(['/quote/success']);
    }

    return true;
};
